import { render, staticRenderFns } from "./feeDetail.vue?vue&type=template&id=670f6566&scoped=true&"
import script from "./feeDetail.vue?vue&type=script&lang=js&"
export * from "./feeDetail.vue?vue&type=script&lang=js&"
import style0 from "./feeDetail.vue?vue&type=style&index=0&id=670f6566&prod&scoped=true&lang=css&"
import style1 from "./feeDetail.vue?vue&type=style&index=1&id=670f6566&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670f6566",
  null
  
)

export default component.exports